import classnames from 'classnames';
import type { FunctionComponent, PropsWithChildren } from 'react';

import { Icon, type IconicNames, type IconicTypes } from '@/atoms/Icons';

interface CardProps {
  title: string;
  icon: IconicNames;
  iconType?: IconicTypes;
  theme?: 'light' | 'dark';
  dataName?: string;
}

export const Card: FunctionComponent<PropsWithChildren<CardProps>> = ({
  title,
  children,
  icon,
  iconType,
  theme = 'light',
  dataName = 'Card',
}) => {
  return (
    <div
      className="border-lightGrey rounded-16 flex shrink-0 flex-row gap-20 border bg-white p-20"
      data-name={dataName}
    >
      <div
        className={classnames('flex h-48 w-48 shrink-0 items-center justify-center rounded-full', {
          'bg-ultramarine text-white': theme === 'dark',
          'bg-lightSand text-black': theme === 'light',
        })}
      >
        <Icon name={icon} type={iconType} width="24px" />
      </div>
      <div className="space-y-8 font-sans">
        <div className="text-b3 font-semibold">{title}</div>
        <div className="text-b4 font-normal">{children}</div>
      </div>
    </div>
  );
};
